/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { ReplaceOneBaseAodRulesControllerAodRuleMutationRequest, ReplaceOneBaseAodRulesControllerAodRuleMutationResponse, ReplaceOneBaseAodRulesControllerAodRulePathParams } from "../models/ReplaceOneBaseAodRulesControllerAodRule";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { replaceOneBaseAodRulesControllerAodRule } from "../axios/replaceOneBaseAodRulesControllerAodRule";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const replaceOneBaseAodRulesControllerAodRuleMutationKey = () => ["audit-reports-api", { url: '/aod-rules/:id' }] as const

export type ReplaceOneBaseAodRulesControllerAodRuleMutationKey = ReturnType<typeof replaceOneBaseAodRulesControllerAodRuleMutationKey>

export function replaceOneBaseAodRulesControllerAodRuleMutationOptions<TContext = unknown>(config: Partial<RequestConfig<ReplaceOneBaseAodRulesControllerAodRuleMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = replaceOneBaseAodRulesControllerAodRuleMutationKey()
        return mutationOptions<ReplaceOneBaseAodRulesControllerAodRuleMutationResponse, ResponseErrorConfig<Error>, {id: ReplaceOneBaseAodRulesControllerAodRulePathParams["id"], data: ReplaceOneBaseAodRulesControllerAodRuleMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ id, data }) => {
            return replaceOneBaseAodRulesControllerAodRule(id, data, config)
          },
        })

}

/**
 * @summary Replace a single AodRule
 * {@link /aod-rules/:id}
 */
export function useReplaceOneBaseAodRulesControllerAodRule<TContext>(options: 
{
  mutation?: UseMutationOptions<ReplaceOneBaseAodRulesControllerAodRuleMutationResponse, ResponseErrorConfig<Error>, {id: ReplaceOneBaseAodRulesControllerAodRulePathParams["id"], data: ReplaceOneBaseAodRulesControllerAodRuleMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ReplaceOneBaseAodRulesControllerAodRuleMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? replaceOneBaseAodRulesControllerAodRuleMutationKey()

          const baseOptions = replaceOneBaseAodRulesControllerAodRuleMutationOptions(config) as UseMutationOptions<ReplaceOneBaseAodRulesControllerAodRuleMutationResponse, ResponseErrorConfig<Error>, {id: ReplaceOneBaseAodRulesControllerAodRulePathParams["id"], data: ReplaceOneBaseAodRulesControllerAodRuleMutationRequest}, TContext>
          

          return useMutation<ReplaceOneBaseAodRulesControllerAodRuleMutationResponse, ResponseErrorConfig<Error>, {id: ReplaceOneBaseAodRulesControllerAodRulePathParams["id"], data: ReplaceOneBaseAodRulesControllerAodRuleMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ReplaceOneBaseAodRulesControllerAodRuleMutationResponse, ResponseErrorConfig<Error>, {id: ReplaceOneBaseAodRulesControllerAodRulePathParams["id"], data: ReplaceOneBaseAodRulesControllerAodRuleMutationRequest}, TContext>
      
}